/*
 * @Descripttion: 
 * @Author: dong
 * @Date: 2025-03-05 11:48:03
 * @LastEditors: dong
 * @LastEditTime: 2026-01-22 11:08:05
 */
export function loadBMap(funcName) {
  var script = document.createElement("script");
  script.src = "https://api.map.baidu.com/api?type=webgl&v=2.0&ak=Pqqzs7VQvrKLSfHHKJrQYTAedLmRs7yW&callback=" + funcName;
  // script.src = "http://api.map.baidu.com/api?v=2.0&ak=4SohswS24sY2IWAiMmntfpR398zEXjVm&callback=" + funcName;
  document.body.appendChild(script);
}